import { useIsFetching } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Glyphicon } from 'react-bootstrap';
import { PROPERTIES_EXPECTATIONS_BASE_QUERY_KEY } from 'components/domain/property/expectation/propertyExpectationQuery';
import SectionHeader from 'components/sectionHeader/SectionHeader';
import Button from 'components/button/Button';
import PropertyEditActionWrapper from 'pages/property/common/PropertyEditActionWrapper';
import usePropertyExpectationAddEditModal from './modals/usePropertyExpectationAddEditModal';

const PropertyExpectationsHeader = () => {
  const { openAddPropertyExpectationModal } =
    usePropertyExpectationAddEditModal();
  const { t } = useTranslation();
  const amountOfPropertyExpectationsQueries = useIsFetching({
    queryKey: [PROPERTIES_EXPECTATIONS_BASE_QUERY_KEY],
  });
  const isFetchingPropertyExpectations =
    amountOfPropertyExpectationsQueries > 0;

  return (
    <SectionHeader
      id="property-expectations"
      title={t('pageProperty.feesTaxesAndPolicies.propertyExpectations.title')}
      tooltip={t(
        'pageProperty.feesTaxesAndPolicies.propertyExpectations.tooltip',
      )}
      buttons={
        <PropertyEditActionWrapper tooltipId="property-expectations-button-tooltip">
          <Button
            bsStyle="primary"
            data-testid="property-expectations-button"
            disabled={isFetchingPropertyExpectations}
            onClick={openAddPropertyExpectationModal}
          >
            <Glyphicon glyph="plus" />
            {t(
              'pageProperty.feesTaxesAndPolicies.propertyExpectations.addExpectation',
            )}
          </Button>
        </PropertyEditActionWrapper>
      }
    />
  );
};

export default PropertyExpectationsHeader;
